export default {
  DATE_FORMAT: 'MM-dd-yyyy',
  DATE_SHORT_MONTH: 'MMM, dd yyyy',
  DATE_SLASH: 'MM/dd/yyyy',
};

export enum UILocale {
  NOT_SPECIFIED = '',
  EN_US = 'en-US',
  FR_CA = 'fr-CA',
  EN_CA = 'en-CA',
  ES_US = 'es-US',
}

export const COUNTRIES = {
  CANADA: 'CA',
  UNITED_STATES: 'US',
};
export const LOCALES = ['en_US', 'es_US', 'fr_CA', 'en_CA']; // First element is default locale
export const FEATURE_FLAGS = {
  INVESTMENTS: 'INVESTMENTS',
  RETIREMENT_CALCULATOR: 'RETIREMENT-CALCULATOR',
  POL_CHILDCONVERT: 'POL-CHILDCONVERT',
  DEBT_SOLUTIONS: 'DEBT-SOLUTIONS',
  CUST_VERIFYPHONE: 'CUST-VERIFYPHONE',
  BENEFICIARIES: 'BENEFICIARIES',
  BENEFICIARIES_EDIT: 'BENEFICIARIES_EDIT',
  ENVESTNET_SSO: 'ENVESTNET-SSO',
  ECOMM: 'ECOMM',
  INVESTMENT_CUSTODIAN: 'INVESTMENT-CUSTODIAN',
  VIEW_ACCOUNT_NUMBER: 'VIEW-ACCOUNT-NUMBER',
  ACCOUNT_SETTING_INVESTMENT_PAPERLESS: 'CA-EDELIVERY',
};

export const ALERT_VIEW_CONTEXT = {
  VERIFY_PHONE: 'verify_phone',
};

export const CHANNELS = {
  SMS: 'SMS',
  Email: 'Email',
};

export const DOCUMENT_OBJECT_TYPES = {
  CRC: 'CP6',
  PREMIUM_DUE: ['INTB', 'LAPR', 'UPIG', 'NPTP'],
};

export const MAX_NOTIFICATIONS_TO_SHOW = window.appConfig.maxNotificationsToShow;
